import Button from "../../components/ui/Button";
import { useForm } from "react-hook-form";
import Auth from "../../services/Auth";
import FieldError from "../../components/ui/FieldError";
import { useParams } from "react-router";
import { useNavigate } from "react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Base from "../base";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/pro-solid-svg-icons";
import PasswordRequirement from "../../components/ui/PasswordRequirement";
import LogoHead from "../../components/LogoHead";

function Reset() {
  const form = useForm();
  const { token } = useParams();
  const [successMsg, setSuccessMsg] = useState();
  const [passwordShown, setPasswordShown] = useState(false);
  const { t } = useTranslation();

  let navigate = useNavigate();

  const onSubmit = async (data) => {
    setSuccessMsg(null);
    try {
      let response = await Auth.reset({
        token,
        plainPassword: {
          first: data.first,
          second: data.second,
        },
      });

      setSuccessMsg(response.data.message);
    } catch ({ response }) {
      if (response?.data) {
        form.setError("first", {
          type: "manual",
          message: response.data?.plainPassword
            ? response.data.plainPassword[0]
            : response.data.message,
        });
      }
    }
  };

  const togglePasswordShown = () => {
    setPasswordShown(!passwordShown);
  };

  return (
    <Base navbar={false}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex flex-col py-16 justify-center items-center">
          <LogoHead />
          <div className="mt-16 p-4 px-6 xl:flex w-4/5 lg:w-2/5">
            <div className="w-full grid">
              <span className="text-2xl mb-4 text-bioport-blue font-bold">
                {t("login.password.new_pass")}
              </span>

              {!successMsg ? (
                <>
                  <div className="relative">
                    <input
                      {...form.register("first")}
                      name="first"
                      type={passwordShown ? "text" : "password"}
                      className="w-full"
                      placeholder={t("login.password.new_pass")}
                    />
                    <div className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5">
                      <FontAwesomeIcon
                        icon={passwordShown ? faEye : faEyeSlash}
                        className={`${
                          passwordShown
                            ? "text-bioport-blue-dark"
                            : "text-gray-400"
                        } cursor-pointer mr-2`}
                        onClick={() => togglePasswordShown()}
                      />
                    </div>
                  </div>

                  <input
                    {...form.register("second")}
                    name="second"
                    type={passwordShown ? "text" : "password"}
                    className="w-full mt-2"
                    placeholder={t("login.password.repeat_pass")}
                  />
                  <FieldError error={form.formState?.errors?.first} />

                  <PasswordRequirement />

                  <div className="flex items-center justify-end mt-4 pt-3">
                    <div>
                      <Button
                        className="btn btn-primary"
                        isloading={form.formState.isSubmitting}
                      >
                        {t("login.password.change_pass")}
                      </Button>
                    </div>
                  </div>
                </>
              ) : (
                <div className="text-center flex flex-col">
                  <div className="mb-4 bg-green-100 px-6 py-3 border rounded-lg border-green-300 text-green-800 text-sm">
                    {successMsg}
                  </div>
                  <div
                    className="btn btn-primary cursor-pointer mt-3"
                    onClick={() => navigate("/", { replace: true })}
                  >
                    {t("login.back_login")}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
    </Base>
  );
}

export default Reset;
